import { render, staticRenderFns } from "./UsersViewTable.vue?vue&type=template&id=6525c8cd&scoped=true&lang=pug&"
import script from "./UsersViewTable.vue?vue&type=script&lang=js&"
export * from "./UsersViewTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersViewTable.vue?vue&type=style&index=0&id=6525c8cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525c8cd",
  null
  
)

export default component.exports